import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { environment, clientId } from '../../env/environment';
import { map, catchError } from 'rxjs/operators';
import User from '../user-auth/User';
import { IEcsAccountData } from './ecs.model';

@Injectable({
    providedIn: 'root'
})

export class EcsService {
    private http: HttpClient;

    constructor(handler: HttpBackend, private cookieService: CookieService) {
        this.http = new HttpClient(handler);
    }
    
    public getEcsInformation() {
            return this.http
            .get<any>(`${environment.ecsBasePath}/session`, {
                headers: new HttpHeaders({
                    'Auth': this.cookieService.get('Valgrind-AU'),
                    'client-id': clientId.ecsClientId
                })
            })
            .pipe(
                map((data: IEcsAccountData) => {
                    return new User({
                        phone: User.formatPhone(data.cellphone),
                        email: data.email
                    });
                }),
                catchError(error => {
                    throw error;
                })
            );
    }
}